import { render, staticRenderFns } from "./TestListEditRoute.vue?vue&type=template&id=b0c53354&scoped=true&"
import script from "./TestListEditRoute.vue?vue&type=script&lang=js&"
export * from "./TestListEditRoute.vue?vue&type=script&lang=js&"
import style0 from "./TestListEditRoute.vue?vue&type=style&index=0&id=b0c53354&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0c53354",
  null
  
)

export default component.exports